import { AsButton, AsSelect } from '@adserve/adserve-react-components';
import React, { useEffect, useState } from 'react';
import { GetContactRoles } from '../../../../services/CampaignsDataService';
import ContactsCompactTable from '../../../generic/ContactsCompactTable/ContactsCompactTableNew';
import { ContactsLookup } from '../CampaignBriefLookupService';
import {
    compactTableInputStyle,
    inputStyle,
    labelStyle
} from '../CampaignBriefStyles';
import ContactCompactTableColumnDefinitions from '../ColumnDefinitions/ContactCompactTableColumnDefinitions';

const AddContact = ({ editingContact, campaign, onChange, readOnly, contactRoles, setContactRoles }) => {
    // This is only here so the compact table behaves itself
    const [contactName, setContactName] = useState();
    const [newContact, setNewContact] = useState();

    const loadData = async () => {
        try {
            const response = await GetContactRoles();
            setContactRoles(response);
        } catch (error) {
            console.log(error);
        }
    };

    useEffect(() => {
        loadData();
    }, []);

    useEffect(() => {
        if (editingContact) {
            setNewContact(editingContact);
            setContactName(editingContact?.contact?.fullName);
        }
    }, [editingContact]);

    useEffect(() => {
        if (campaign?.id && !newContact) {
            setNewContact(emptyContact());
        }
    }, [campaign.id]);

    const emptyContact = () => {
        return {
            campaignId: campaign.id,
            contactId: null,
            contact: {
                fullName: '',
                emailWork: null,
                mobileNumber: null,
                account: { name: null }
            },
            contactRoleId: null,
            contactRole: { id: null, name: null }
        };
    };

    const handleContactChange = (event) => {
        setContactName(event.target.value);
    };

    const handleContactDropdownClick = (searchResult) => {
        setNewContact({
            ...newContact,
            contactId: searchResult.id,
            contact: {
                id: searchResult.id,
                fullName: searchResult.name,
                emailWork: searchResult.emailWork,
                mobileNumber: searchResult.mobileNumber,
                account: { name: searchResult.accountName }
            }
        });
        setContactName(searchResult.name);
    };

    const handleRoleChange = (event) => {
        const role = contactRoles.find((x) => x.id === event.target.value);

        setNewContact({
            ...newContact,
            contactRoleId: role.id,
            contactRole: { id: role.id, name: role.name }
        });
    };

    const handleAddCampaignContactClick = () => {
        const contacts = campaign.campaignContacts
            ? campaign.campaignContacts
            : [];

        if (editingContact?.index >= 0) {
            contacts[editingContact?.index] = newContact;
        } else {
            contacts.push({ ...newContact });
        }
        onChange(contacts);

        setNewContact(emptyContact());
        setContactName('');
    };

    const hasValidValues = () => {
        return (
            contactName === newContact?.contact?.fullName &&
            newContact?.contact?.id &&
            newContact?.contactRole?.id
        );
    };

    return (
        <div
            style={{
                display: 'flex',
                justifyContent: 'space-between',
                width: '60%',
                marginBottom: 18
            }}
        >
            <div style={{ width: 280 }}>
                <label style={labelStyle}>
                    {window.translate('Contact name')}
                </label>
                <ContactsCompactTable
                    id='campaign-contact'
                    inputStyle={compactTableInputStyle}
                    value={contactName}
                    onChange={handleContactChange}
                    minSearchLength={0}
                    searchFunction={(searchTerm, params) =>
                        ContactsLookup(searchTerm, params)
                    }
                    tableColumnDefinitions={
                        ContactCompactTableColumnDefinitions
                    }
                    onDropdownClick={handleContactDropdownClick}
                    disabled={readOnly}
                    searchFilter={[]}
                />
            </div>
            <AsSelect
                id='campaign-role-input'
                name='campaignRoleId'
                title={window.translate('Role')}
                values={contactRoles}
                value={newContact?.contactRole?.id}
                onChange={handleRoleChange}
                labelStyle={{ ...labelStyle, marginBottom: 0 }}
                inputStyle={{ ...inputStyle, width: 280 }}
                disabled={readOnly}
                placeholder={window.translate('Select...')}
            />
            <AsButton
                style={{
                    fontSize: 15,
                    fontWeight: 'bold',
                    alignSelf: 'flex-end',
                    marginBottom: 5,
                    width: 120
                }}
                handleClick={handleAddCampaignContactClick}
                disabled={readOnly || !hasValidValues()}
            >
                {window.translate(editingContact ? 'Update' : 'Add')}
            </AsButton>
        </div>
    );
};

export default AddContact;
